import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/input.tsx
function n({ className: n, type: r, ...i }) {
	return /* @__PURE__ */ t("input", {
		type: r,
		"data-slot": "input",
		className: e("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 aria-invalid:border-destructive", n),
		...i
	});
}
//#endregion
export { n as Input };
